import { render, staticRenderFns } from "./Artist.vue?vue&type=template&id=e845b368&scoped=true"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"
import style0 from "./Artist.vue?vue&type=style&index=0&id=e845b368&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e845b368",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeaderArtist: require('/vercel/path0/components/page/HeaderArtist.vue').default,Picture: require('/vercel/path0/components/elements/Picture.vue').default,SocialMedia: require('/vercel/path0/components/elements/SocialMedia.vue').default,Button: require('/vercel/path0/components/elements/Button.vue').default,PageFooter: require('/vercel/path0/components/page/Footer.vue').default})
